// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- using new design system colors */
:root {
    /* Level 1 */
    --ds-box-level1-bg-color: var(--ds-color-grey-indigo-100);
    /* Level 2 */
    --ds-box-level2-bg-color: var(--ds-color-grey-indigo-90);
    --ds-box-level2-border-color: var(--ds-color-grey-indigo-50);
    /* Level 2 alt */
    --ds-box-level2a-bg-color: var(--ds-gradient-1);
    --ds-box-level2a-border-color: var(--ds-color-grey-indigo-50);
    /* Level 3 */
    --ds-box-level3-bg-color: var(--ds-color-grey-indigo-80);
    --ds-box-level3-border-color: var(--ds-color-grey-indigo-40);
    /* Level 4 */
    --ds-box-level4-bg-color: var(--ds-color-grey-indigo-70);
    --ds-box-level4-border-color: var(--ds-color-grey-indigo-30);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
